import React from "react";
import { Card, styled } from "@mui/material";
import usePrimaryColor from "../../hooks/usePrimaryColor";
const width = "325px";
const height = "200px";
// Styled Card for layout with dynamic border and hover effect
const StyledCard = styled(Card)(({ theme, checked, color }) => ({
  margin: theme.spacing(1),
  padding: theme.spacing(2),
  display: "flex",
  width: width,
  minHeight: height,
  maxHeight: height,
  alignItems: "center",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  borderRadius: theme.shape.borderRadius,
  border: checked ? `2px solid ${color}` : "none",
  cursor: "pointer",
  transition: "transform 0.2s",
  // Only apply hover effects on devices that support hover
  //Hover effect will be automatically disabled on mobile by this
  "@media (hover: hover)": {
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
    },
  },
}));

const StyledCardNoHover = styled(Card)(({ theme, checked, color }) => ({
  margin: theme.spacing(1),
  padding: theme.spacing(2),
  display: "flex",
  width: width,
  minHeight: "160px",
  maxHeight: "160px",
  alignItems: "center",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  borderRadius: theme.shape.borderRadius,
  border: checked ? `2px solid ${color}` : "none",
  cursor: "pointer",
  transition: "transform 0.2s",
}));

const StyledCardSmall = styled(Card)(({ theme, checked, color }) => ({
  margin: theme.spacing(1),
  padding: theme.spacing(2),
  display: "flex",
  width: width,
  alignItems: "center",
  borderRadius: theme.shape.borderRadius,
  border: checked ? `2px solid ${color}` : "none",
  cursor: "pointer",
  transition: "transform 0.2s",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
  },
}));

export default function SelectableCard({
  checked,
  hover = true,
  small = false,
  children,
  ...props
}) {
  const color = usePrimaryColor();
  if (small) {
    return (
      <StyledCardSmall color={color} checked={checked} {...props}>
        {children}
      </StyledCardSmall>
    );
  } else if (hover == false) {
    return (
      <StyledCardNoHover color={color} checked={checked} {...props}>
        {children}
      </StyledCardNoHover>
    );
  }
  return (
    <StyledCard color={color} checked={checked} {...props}>
      {children}
    </StyledCard>
  );
}
